// 首页列表组件
import * as React from 'react'
import HomeType from '../../../types/HomeType'
import * as Styles from './HomeItemListItem.style'
import {deletePictureParams, renderPopular} from '../../../../../utils/tools'
import {classes} from 'typestyle'
// tslint:disable-next-line
const {LazyLoadImage} = require('react-lazy-load-image-component')

interface HomeLimitBarProp {
    content: HomeType.Content,
    topMargin?: number,
    bottomMargin?: number,
    is_anniversary: boolean,
    invite_id: number
}

function HomeItemListItem(props: HomeLimitBarProp) {
    const content = props.content
    const invite_id = props.invite_id
    const is_anniversary = props.is_anniversary
    const getDistance = {
        paddingTop: props.topMargin ? props.topMargin : '',
        paddingBottom: props.bottomMargin ? props.bottomMargin : ''
    }

    const renderPrice = () => {
        // if (content.stype === 'coupon') {
        //     return (
        //         <div className={Styles.couponTagSm}>
        //             <div className={Styles.couponTagSmText}>立减{content.meta && content.meta.desc}元</div>
        //         </div>
        //     )
        // }
        if (content.need_money) {
            if (content.has_limitmoney) {
                if (Number(content.limit_money) === 0) {
                    return <p><span>限时免费</span></p>
                } else {
                    // tslint:disable-next-line
                    return <p><i style={{fontStyle:'normal', fontSize: 12}}>￥</i>{content.limit_money.split('.')[0]}<span>.{content.limit_money.split('.')[1]}</span></p>
                }
            } else {
                // tslint:disable-next-line
                return <p><i style={{fontStyle:'normal', fontSize: 12}}>￥</i>{content.lecture_money.split('.')[0]}<span>.{content.lecture_money.split('.')[1]}</span></p>
            }
        } else {
            if (content.lecture_type !== 'pay_channel') {
                return <span className={Styles.HomeItemRightFreeLecture}>免费</span>
            } else {
                return null
            }
        }
    }

    const renderLectureTime = () => {
        if (content.lecture_mode === 'video' || content.lecture_mode === 'audio') {
            return (
                <p>时长<span>{content.audio_length}</span>分钟</p>
            )
        }

        if (content.status === 'closed') {
            if (content.audio_length <= 5) {
                return (
                    <p>{content.start_time.split(' ')[0]}</p>
                )
            } else {
                return (
                    <p>时长<span>{content.audio_length}</span>分钟</p>
                )
            }
        } else {
            return (
                <p>{content.status_name}</p>
            )
        }
    }

    const ifIsLivingStatus = () => {
        if (content.start_name === '正在直播') {
            return true
        } else {
            return false
        }
    }

    const clickItem = (detail) => {
       if (is_anniversary) {
        if (detail.return_money === 0) {
            return location.assign(detail.url)
        } else {
            return location.assign(`${window.location.origin}/activity/triennial/?id=${detail.id}&inviter_id=${invite_id}&reduce=${detail.return_money}`)
        }
       }
       if ( detail.stype === 'coupon' ) {
            location.assign(detail.url + `&${detail.meta.params}`)
       } else {
            location.assign(detail.url)
       }
    }

    return (
        <a style={getDistance} className={Styles.HomeItemListItem} onClick={() => clickItem(content)}>
            <div className={Styles.HomeItemLeft}>
                    <div className={Styles.HomeItemLeftBgImage}>
                            {window.location.pathname !== '/category' ?
                                <LazyLoadImage
                                    alt={content.cover_url ? content.cover_url : content.cover}
                                    effect="blur"
                                    src={content.cover_url ? `${deletePictureParams(content.cover_url)}?imageView2/2/w/300/q/85!` : `${deletePictureParams(content.cover)}?imageView2/2/w/300/q/85!`}
                                /> :
                                <img src={content.cover_url ? `${deletePictureParams(content.cover_url)}?imageView2/2/w/300/q/85!` : `${deletePictureParams(content.cover)}?imageView2/2/w/300/q/85!`} alt=""/>
                            }
                    </div>

                <div className={Styles.StudyTotalNum}>
                    <div className={Styles.StudyTotalNumDiv}>
                        <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                        {renderPopular(content.popular)}人
                    </div>
                </div>
                {/* {
                        content.stype === 'coupon' && (
                            <div>
                                <div className={Styles.couponTagBig}/>
                                <div className={Styles.couponTagBigText}>
                                    <p>立减</p>
                                    <p><span>{content.meta && content.meta.desc}</span></p>
                                </div>
                            </div>
                        )
                    } */}
            </div>

            <div className={Styles.HomeItemRight}>
                <div className={classes(Styles.HomeItemRightTitle, 'TextChangeToTwoLines')}>
                    {is_anniversary && (
                        <div className={Styles.threeActivity}>
                           <span>返{content.return_money / 100}元</span>
                        </div>
                    )}
                     {/* 3.3活动特例 */}
                    {content.name ? content.name : content.title}
                </div>

                <div className={Styles.HomeItemLeftBottom}>
                    <div className="currency-item-right-bottom_left-count-time" style={{color: '#999999'}}>
                        {content.type && content.type === 'channel' && !ifIsLivingStatus() &&
                            <p>已更新<span>{content.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期</p>
                        }
                        {(content.type && content.type === 'lecture') && !ifIsLivingStatus() &&
                            renderLectureTime()
                        }
                        {ifIsLivingStatus() &&
                        <div className="HomeItemLeftBottom">
                            <div className={Styles.isLivingText}>
                                <img className={Styles.LiveStatusImg} src="https://static-cos.lycheer.net/picture/7931794_e27bd04f8061e533ae1851e0928b2f50.jpg" alt=""/>
                            正在直播
                            </div>
                        </div>
                        }
                    </div>

                    <div className={Styles.HomeItemRightBotton}>
                        {(content.type) &&
                            <div className={Styles.HomeItemRightBottonRight}>
                                {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                    <p className="HomeItemRightBottonRightLimit"><del>￥{content.lecture_money}</del></p>
                                }
                                {renderPrice()}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </a>
    )

}

export default HomeItemListItem



// WEBPACK FOOTER //
// ./src/views/Home/components/TriennialsSpecial/HomeItemListItem/HomeItemListItem.tsx